var buy    = require('./component/buy');

var bounce = require('./component/bounce');

var sections = [];


bounce.setFlashHistoryEnabled(false);
bounce.appendMode(function(frame, node, appending) {

  var key = $(node).data('parent');

  if(sections[key]) {
    var body = $(sections[key]).find('.bounce-section-body');

    appending ? body.append(node) : body.prepend(node);

    
  }
  else{

    var newsection = $('.bounce-section')[0].outerHTML;
        newsection = $(newsection);

    $(newsection).attr('data-section', key).data('section', key);
    $(newsection).find('.bounce-section-title').text(key);

    var body = newsection.find('.bounce-section-body');

        body.html('');

    appending ? body.append(node) : body.prepend(node);

    frame.append(newsection);

    sections[key] = newsection;
  }
});

bounce.onSuccess(function() {
  buy.render();
});


jQuery(document).ready(function($) {
  
  var bsections = $('.bounce-section');
  for (var i = 0; i < bsections.length; i++) {
    sections[$(bsections[i]).data('section')] = bsections[i];
  }

});


var queue = require('./component/queue');

queue.on('start', '#taskExport', function(queuer) { 
  $('#modalExport').data('locked', true);
});

queue.on('kill', '#taskExport', function(queuer) {
  $('#modalExport').data('locked', false);
});

var interval;
queue.on('finish', '#taskExport', function(queuer){

  var timer = 1800;
  var timerformat = new Date(timer * 1000);

  $('#modalExport').data('locked', false);

  $('#modalExport .modal-body').append(
    $('<div>').addClass('row mt-2 download-section').append(
      $('<div>').addClass('col-12 text-right font-weight-bold').append(

        $('<i>').addClass('fa fa-stopwatch text-muted'),

        ' ',

        $('<span>').addClass('stopwatch').text(timerformat.getMinutes().toString().padStart(2, '0') + ':' + timerformat.getSeconds().toString().padStart(2, '0')),

        ' ',

        $('<a>').attr('target', '_blank').attr('href', `/download/${queuer.data('queue-id')}`).text('Descargar archivo'),
      )
    )
  );


  window.location.href = '/download/' + queuer.data('queue-id');

  clearInterval(interval)

  interval = setInterval(function() {
    timer--;
    timerformat = new Date(timer * 1000);
    $('.stopwatch').text(timerformat.getMinutes().toString().padStart(2, '0') + ':' + timerformat.getSeconds().toString().padStart(2, '0'));
    if(timer == 0) {
      clearInterval(interval);
      $('.download-section').remove();
    }
  }, 1000)
})

$('#modalExport').on('hide.bs.modal', function (e) {
  $('#modalExport').find('.download-section').remove();
  if($(this).data('locked')) {
    e.preventDefault();
    e.stopPropagation();
  }
  else{
    var queuer = $(this).find('.queue');
    queue.kill(queuer);
  }
});